// The anchor keeps no height of its own, so the row paints into the padding
// below the last message instead of pushing the composer down.
export const TYPING_ANCHOR_CLASS = "relative h-0"
// The row lines up with the timeline events above it: the avatar sits in the
// same 32px icon column, offset by the same rail, and the label starts where theirs does.
export const TYPING_ROW_CLASS = "absolute left-0.5 top-1 flex h-5 items-center"
export const TYPING_AVATAR_COLUMN_CLASS = "flex w-8 justify-center"
export const TYPING_LABEL_GAP_CLASS = "gap-2.5"
// The timeline reserves this much bottom padding whether or not anyone is
// typing, so the row always has room to paint into and nothing reflows.
export const TIMELINE_BOTTOM_PADDING_CLASS = "pb-8"
// The fade over the last message; the typing row's text has to sit above it.
export const TIMELINE_BOTTOM_FADE_CLASS =
	"absolute bottom-0 left-0 right-0 z-10 h-3 bg-gradient-to-t from-white/90 to-transparent dark:from-gray-900/90"

// The socket can still be in another chat's room (a widget thread has no session
// until the first reply), so only this thread's own session may show a typer.
export const isTypingForSession = (
	data: { sessionId?: string },
	sessionId: string | undefined,
): boolean => !!sessionId && data.sessionId === sessionId

export const leftInsetUnitFromClass = (
	className: string,
): number | undefined => {
	const match = /(?:^|\s)(?:pl|left)-(\d+(?:\.\d+)?)(?:\s|$)/.exec(className)
	return match ? Number(match[1]) : undefined
}

export const gapUnitFromClass = (className: string): number | undefined => {
	const match = /(?:^|\s)gap-(\d+(?:\.\d+)?)(?:\s|$)/.exec(className)
	return match ? Number(match[1]) : undefined
}

export const unitFromClass = (
	className: string,
	prefix: string,
): number | undefined => {
	const match = new RegExp(
		`(?:^|\\s)${prefix}-(?:(\\d+(?:\\.\\d+)?)|\\[(\\d+(?:\\.\\d+)?)px\\])(?:\\s|$)`,
	).exec(className)
	if (!match) return undefined
	// Arbitrary px values convert to Tailwind units (4px each)
	return match[1] ? Number(match[1]) : Number(match[2]) / 4
}
